import React, { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'

import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'

type Props = {
  name: Features
  render?: (args: { isEnabled?: boolean }) => React.ReactElement | null
}

const Flag = ({ render, name, children }: PropsWithChildren<Props>) => {
  const isEnabled: boolean = useSelector(isFeatureEnabled(name))

  if (render) {
    return render({ isEnabled })
  }

  return isEnabled ? <>{children}</> : null
}

const WrappedFlag = ({ render, name, children }: PropsWithChildren<Props>) => (
  <Flag name={name} render={render}>
    {children}
  </Flag>
)

export { WrappedFlag as Flag }
